const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center bg-gray-50">
      <h1 className="text-6xl font-bold text-red-600">404</h1>
      <p className="mt-4 text-gray-600 text-lg">Page Not Found</p>
      <p className="mt-2 text-gray-400 text-sm">
        The page you are looking for does not exist.
      </p>
    </div>
  );
};

export default NotFoundPage;